"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mixins = require("../mixins");

var _utils = require("../utils");

var popoverContentMixin = function popoverContentMixin(_ref) {
  var selectors = _ref.selectors,
      isOpen = _ref.isOpen,
      transitionTime = _ref.transitionTime,
      shouldSlideUp = _ref.shouldSlideUp,
      isSmallScreen = _ref.isSmallScreen;
  return "\n  overflow-y: auto;\n  max-height: ".concat(isSmallScreen ? '60vh' : '80vh', ";\n  transition: transform ").concat(transitionTime, "s;\n  transform: translate(0, ").concat(isOpen ? 0 : shouldSlideUp ? '16px' : '-16px', ");\n  \n  :focus {\n    outline: 2px solid ").concat(selectors.color('primary'), ";\n  }\n");
};

popoverContentMixin.propTypes = {
  selectors: _propTypes.default.any.isRequired,
  isOpen: _propTypes.default.bool,
  transitionTime: _propTypes.default.number,
  shouldSlideUp: _propTypes.default.bool,
  isSmallScreen: _propTypes.default.bool
};
var popoverContentMixins = (0, _utils.combineMixins)(_mixins.paddingMixin, popoverContentMixin);
var PopoverContent = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "ewj86t20"
})(popoverContentMixins, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BvcG92ZXItbGVnYWN5L1BvcG92ZXJDb250ZW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlDb0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvcG9wb3Zlci1sZWdhY3kvUG9wb3ZlckNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBwYWRkaW5nTWl4aW4gfSBmcm9tICcuLi9taXhpbnMnO1xuaW1wb3J0IHsgY29tYmluZU1peGlucyB9IGZyb20gJy4uL3V0aWxzJztcblxuY29uc3QgcG9wb3ZlckNvbnRlbnRNaXhpbiA9ICh7XG4gIHNlbGVjdG9ycyxcbiAgaXNPcGVuLFxuICB0cmFuc2l0aW9uVGltZSxcbiAgc2hvdWxkU2xpZGVVcCxcbiAgaXNTbWFsbFNjcmVlblxufSkgPT4gYFxuICBvdmVyZmxvdy15OiBhdXRvO1xuICBtYXgtaGVpZ2h0OiAke2lzU21hbGxTY3JlZW4gPyAnNjB2aCcgOiAnODB2aCd9O1xuICB0cmFuc2l0aW9uOiB0cmFuc2Zvcm0gJHt0cmFuc2l0aW9uVGltZX1zO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgwLCAke2lzT3BlbiA/IDAgOiBzaG91bGRTbGlkZVVwID8gJzE2cHgnIDogJy0xNnB4J30pO1xuICBcbiAgOmZvY3VzIHtcbiAgICBvdXRsaW5lOiAycHggc29saWQgJHtzZWxlY3RvcnMuY29sb3IoJ3ByaW1hcnknKX07XG4gIH1cbmA7XG5cbnBvcG92ZXJDb250ZW50TWl4aW4ucHJvcFR5cGVzID0ge1xuICBzZWxlY3RvcnM6IFByb3BUeXBlcy5hbnkuaXNSZXF1aXJlZCxcbiAgaXNPcGVuOiBQcm9wVHlwZXMuYm9vbCxcbiAgdHJhbnNpdGlvblRpbWU6IFByb3BUeXBlcy5udW1iZXIsXG4gIHNob3VsZFNsaWRlVXA6IFByb3BUeXBlcy5ib29sLFxuICBpc1NtYWxsU2NyZWVuOiBQcm9wVHlwZXMuYm9vbFxufTtcblxuY29uc3QgcG9wb3ZlckNvbnRlbnRNaXhpbnMgPSBjb21iaW5lTWl4aW5zKHBhZGRpbmdNaXhpbiwgcG9wb3ZlckNvbnRlbnRNaXhpbik7XG5cbmNvbnN0IFBvcG92ZXJDb250ZW50ID0gc3R5bGVkKCdkaXYnKWBcbiAgJHtwb3BvdmVyQ29udGVudE1peGluc31cbmA7XG5cblBvcG92ZXJDb250ZW50LmRpc3BsYXlOYW1lID0gJ1BvcG92ZXJDb250ZW50JztcblBvcG92ZXJDb250ZW50LnByb3BUeXBlcyA9IHtcbiAgLi4ucG9wb3ZlckNvbnRlbnRNaXhpbnMucHJvcFR5cGVzLFxuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGVcbn07XG5cblBvcG92ZXJDb250ZW50LmRlZmF1bHRQcm9wcyA9IHtcbiAgaXNPcGVuOiB0cnVlLFxuICB0cmFuc2l0aW9uVGltZTogMC4yLFxuICBzaG91bGRTbGlkZVVwOiBmYWxzZSxcbiAgcGFkZGluZzogMTZcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBvcG92ZXJDb250ZW50O1xuIl19 */");
PopoverContent.displayName = 'PopoverContent';
PopoverContent.propTypes = (0, _objectSpread2.default)({}, popoverContentMixins.propTypes, {
  children: _propTypes.default.node
});
PopoverContent.defaultProps = {
  isOpen: true,
  transitionTime: 0.2,
  shouldSlideUp: false,
  padding: 16
};
var _default = PopoverContent;
exports.default = _default;